import { useNavigate } from "react-router";
import { bemCN } from "../../config/bem-classname";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import "./menu.scss";
import { ReactComponent as ArrowLeftIcon } from "../../shared/images/svg/arrow-left.svg";
import { ReactComponent as DotsIcon } from "../../shared/images/svg/dots.svg";
import Popup from "../../ui/popup/popup";
import { FC, useEffect, useState } from "react";
import { menuItems } from "../../const/menu-items";
import { MenuItem } from "../../view-models/menu-item";
import { authService } from "../../services/auth-service";
import { links } from "../../config/links";
import { Modal } from "../../ui/modal/modal";
import {
  localStorageService,
  LocalStorageVariableName,
} from "../../services/localStorage-service";

const muneCn = bemCN("menu");

export type MenuProps = {
  title: string;
};

export const Menu: FC<MenuProps> = ({ title }) => {
  const navigate = useNavigate();

  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);

  const isAuth: boolean =
    localStorageService.getValue(LocalStorageVariableName.token) == undefined
      ? false
      : true;

  const onClickBack = () => {
    navigate(-1);
  };

  const onClickMenuItem = (link?: string) => {
    if (link) {
      setIsShowMenu(false);
      navigate(link);
    } else {
      setIsShowModal(true);
    }
  };

  const logout = () => {
    setIsShowModal(false);
    authService.logout().then((res: number) => navigate(links.start));
  };

  return (
    <div className={muneCn({ noActiveMenu: !isAuth })}>
      <Button
        icon={<ArrowLeftIcon />}
        color={ButtonColors.grey}
        size={ButtonSizes.small}
        onClick={onClickBack}
      />
      <p>{title}</p>
      <Button
        id="dots_btn"
        // icon={<DotsIcon />}
        color={ButtonColors.grey}
        size={ButtonSizes.small}
        onClick={() => setIsShowMenu(true)}
      />
      <Popup isShow={isShowMenu} setIsShow={setIsShowMenu}>
        <div className={muneCn("popup")}>
          <Button
            icon={<DotsIcon />}
            color={ButtonColors.grey}
            size={ButtonSizes.small}
            onClick={() => setIsShowMenu(false)}
          />

          <div className={muneCn("items")}>
            {menuItems.map((i: MenuItem) => (
              <div
                onClick={() => onClickMenuItem(i.onClickLink)}
                key={i.id}
                className={muneCn("item")}
              >
                {i.icon}{" "}
                <div>
                  <p>{i.name}</p>
                  <p>{i.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Popup>

      <Modal
        id="logoutMenuModal"
        isShowDialog={isShowModal}
        setIsShowDialog={setIsShowModal}
      >
        <div className={muneCn("modal")}>
          <p>Вы уверены что хотите выйти из аккаунта?</p>
          <Button
            onClick={logout}
            color={ButtonColors.violet}
            size={ButtonSizes.big}
            text="Выйти из аккаунта"
          />
          <Button
            onClick={() => setIsShowModal(false)}
            color={ButtonColors.green}
            size={ButtonSizes.big}
            text="Назад"
          />
        </div>
      </Modal>
    </div>
  );
};
